export default __webpack_public_path__ + "static/media/top-100-cropped.43ee4318.png";